import type { IApplicantDetails } from "@/src/types/applicant";
import type { AdmissionTaskPrefillPayload } from "@/src/hooks/useAdmissionTaskPrefill";
import { resolveDisplayDegreeAndCourse } from "@/src/utils/admissionOffice/resolveDisplayDegreeAndCourse";
import { normalizeDateForInput } from "@/src/constants/AdmissionOffice/admissionTaskPrefillMappings";

const pickString = (...values: (string | undefined | null)[]): string => {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
};

export const buildAdmissionPrefillPayloadFromApplicant = (
  applicant: IApplicantDetails,
): AdmissionTaskPrefillPayload => {
  const applicantId = applicant.id;
  const { degree, course: selectedCourse } = resolveDisplayDegreeAndCourse(
    applicant.course,
    applicant.level_education,
  );

  return {
    source: "applicant",
    task_id: "",
    student_id: applicantId,
    applicant_id: applicantId,
    fullName: pickString(applicant.fullname),
    fullNameNat: pickString(applicant.fullname_nat),
    dateOfBirth: normalizeDateForInput(pickString(applicant.birth_date)),
    nationality: pickString(applicant.nationality),
    degree: pickString(applicant.level_education) || degree,
    selectedCourse,
    course: "",
    form_office: pickString(applicant.form_office),
    office_url: pickString((applicant as { office_url?: string | null }).office_url),
    office: pickString(applicant.form_office),
    userEmail: pickString(applicant.email),
    preparatoryDepartment: pickString(applicant.preparatory_department),
    certificationEqualization: pickString(applicant.certification_equalization),
  };
};
